import { FloatingButtonState } from '..';
import { SearchState } from '@reducers/search';
import { mapToSavedSearch } from '@shared/helpers/SavedSearches/stateTranslator';
import { isSearchSaved } from '@shared/helpers/SavedSearches/matcher';
import { DisplayStrategyCallback } from '.';
import type { FiltersConfigState } from '@reducers/filtersConfig';

export function create(state: FloatingButtonState): DisplayStrategyCallback {
  return (search: SearchState, filtersConfig: FiltersConfigState) => {
    return Promise.resolve(
      state.firstFetchDone &&
        !isSearchSaved(
          mapToSavedSearch(search, filtersConfig),
          state.savedSearchesIndex || {}
        )
    );
  };
}
